import React from 'react';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import { useLottieLoadingContext } from 'Organisms/LottieControl/LottieLoadingLayout';
import FromAccountDetails
  from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate/Content/AccountDetailsSection/FromAccountDetails/FromAccountDetails';
import ToAccountDetails
  from 'Views/Page/Content/Templates/RolloverConciergeIntroStepTemplate/Content/AccountDetailsSection/ToAccountDetails/ToAccountDetails';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LottieControl } from 'Organisms/LottieControl';

const AccountDetailsSectionMobile = () => {
  const { resource } = useMetaLayoutContext();
  const { setIsContentShowing } = useLottieLoadingContext();

  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (
    <FDStack direction={'column'} justifyContent={'space-between'} alignItems={'center'} spacing={2}>
      <FromAccountDetails />

      {resource.withRelationship(fr.relationships.transferLottieVertical.name,
        (rel) => (
          <LottieControl
            src={rel.link('related').url()}
            onLoadSuccess={() => setIsContentShowing(true)}
            onLoadError={() => setIsContentShowing(true)}
            height={'auto'}
            width={'auto'}
          />
        ),
        () => null)}

      <ToAccountDetails />
    </FDStack>
  );
};

AccountDetailsSectionMobile.defaultProps = {
};

AccountDetailsSectionMobile.propTypes = {
};

export default AccountDetailsSectionMobile;
